export enum TestId {
  Trend = "trend",
  TrendIcon = "trend-icon",
  Caption = "caption",
  Amount = "amount",
}
